interface HamburgerProps {
  isOpen: boolean;
  onClick: () => void;
}
export const Hamburger = ({ isOpen, onClick }: HamburgerProps) => {
  return (
    <button
      className={`text-dark h-[50px] transition-all ${isOpen ? 'bg-secondary border-secondary' : 'border-dark-100 bg-background-100'} relative z-2 h-[52px] w-[52px] rounded-md border-[1px] focus:outline-none`}
      aria-haspopup="true"
      aria-controls="mainMenu"
      aria-label="Toggle menu"
      onClick={onClick}
    >
      <div className="absolute top-1/2 left-1/2 block w-5 -translate-x-1/2 -translate-y-1/2 transform">
        <span
          aria-hidden="true"
          className={`absolute block h-0.5 w-5 transform ${isOpen ? 'bg-neutral' : 'bg-current'} transition duration-500 ease-in-out ${isOpen ? 'rotate-45' : '-translate-y-1.5'}`}
        ></span>
        <span
          aria-hidden="true"
          className={`absolute block h-0.5 w-5 transform ${isOpen ? 'bg-neutral' : 'bg-current'} transition duration-500 ease-in-out ${isOpen ? 'opacity-0' : 'opacity-100'}`}
        ></span>
        <span
          aria-hidden="true"
          className={`absolute block h-0.5 w-5 transform ${isOpen ? 'bg-neutral' : 'bg-current'} transition duration-500 ease-in-out ${isOpen ? '-rotate-45' : 'translate-y-1.5'}`}
        ></span>
      </div>
    </button>
  );
};
